/**
 * DO NOT EDIT THIS FILE
 * DO NOT EDIT THIS FILE
 * DO NOT EDIT THIS FILE
 * DO NOT EDIT THIS FILE
 * DO NOT EDIT THIS FILE
 *
 *
 * Export environment config.
 *
 * Switch to using the Angular CLI environment file at ./environments/environment
 *
 * @deprecated since version 0.7.0
 */
import { environment } from './environments/environment';

export const CONFIG = environment;
